// src/pages/leads/constants.js

// Status options used in the Leads filters (includes CPTA)
export const STATUS = [
  'NEW',
  'ASSIGNED',
  'SOLD',
  'PM',
  'PMDNH',
  'REAPP',
  'PTA',
  'BO',
  'NCI',
  'CPTA',       // Call-Again: Cancelled Appointment
  'CANCELLED',
  'ARCHIVED',
];

// Call Again statuses (used by Reports → Call Again and to hide by default in Leads)
export const CALL_AGAIN_STATUSES = ['REAPP', 'PTA', 'BO', 'NCI', 'CPTA'];

// “Active” statuses we want to show by default on the Leads page
export const ACTIVE_STATUSES_DEFAULT = STATUS.filter(
  (s) => !CALL_AGAIN_STATUSES.includes(s)
);

// Server-side page size for the live query
export const PAGE_SIZE = 30;

// Sort options (id used in state; field+dir used in Firestore orderBy)
export const SORTS = [
  { id: 'DATE_DESC', label: 'Date: newest first', field: 'createdAt', dir: 'desc' },
  { id: 'DATE_ASC', label: 'Date: oldest first', field: 'createdAt', dir: 'asc' },
  { id: 'POSTCODE_ASC', label: 'Postcode: A → Z', field: 'postcode', dir: 'asc' },
  { id: 'STATUS_ASC', label: 'Status: A → Z', field: 'status', dir: 'asc' },
];

// Presets ONLY for “Cancel Sale” (appointment cancels use free text)
export const SALE_CANCEL_REASONS = [
  'Price too high',
  'Finance decline',
  'Third-party intervened',
  'Went to competitor',
  'Other',
];

// Reasons used by the “Mark as Dead (DNC)” flow
export const DNC_REASONS = [
  'Do Not Contact',
  'Not Interested',
  'Wrong Number',
  'Abusive/Threatening',
  'Spam/Scam',
  'Duplicate Lead',
  'Other',
];
